import httpClient from '../../client'
import apiRoutes from '../constants'

/**
 * @param {number} cityId
 * @return {Promise<*>}
 */
const getShowcase = async (cityId) => {
  try {
    const url = `${apiRoutes.GET_CITIE}/${cityId}/showcase`
    const {data} = await httpClient.get(url)

    if (data) {
      return data
    }

    throw data
  } catch (error) {
    console.log(`Error calling citie with ${JSON.stringify(cityId)}`, error)
    return error
  }
}

export default getShowcase
